import type { SVGProps } from "react";

export const Daytona = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    viewBox="192 120 68 80"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Daytona</title>
    <path d="M195.994 172.235h24.929v8.547h-24.929zm33.477-29.915h28.491v8.547h-28.491zm-14.958 2.634 21.153-21.153 6.044 6.044-21.153 21.153z" />
    <path d="m214.644 166.322-16.246-16.246-6.043 6.044 16.245 16.246zm21.368 11.957-17.124 17.124-6.044-6.044 17.124-17.124zm-.131-21.368 19.139 19.139 6.043-6.044-19.138-19.139zm-21.368-21.002v20.656h-8.547v-20.656z" />
    <path d="M244.428 165.825v25.642h-8.547v-25.642z" />
  </svg>
);

export default Daytona;
